import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

declare const Intercom: any;

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private matSnackBar: MatSnackBar) {}
  public showMessage(message: string, duration = 2000): void {
    this.matSnackBar.open(`${message}`, null, { duration });
  }
  public show(message: string, duration = 2000): void {
    this.showMessage(message, duration);
  }

  public showError(message: string, linkToSupport = false): void {
    if (linkToSupport && typeof Intercom !== 'undefined') {
      const ref = this.matSnackBar.open(message, 'Contact Support', {
        panelClass: ['bg-red-500', 'snackbar-error'],
        duration: 3000,
      });
      const sub = ref.onAction().subscribe(() => {
        Intercom('showNewMessage');
      });
      ref
        .afterDismissed()
        .toPromise()
        .then(() => {
          if (sub) {
            sub.unsubscribe();
          }
        });
    } else {
      this.matSnackBar.open(message, null, {
        panelClass: ['bg-red-500'],
        duration: 2000,
      });
    }
  }
}
